/**
 * Hub & action icons — aligned with product mock / Lucide shapes.
 * viewBox 0 0 24 24, stroke icons unless noted.
 */

const svgStroke =
    'xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';

/** Solid lightbulb (feature request) — matches mock black bulb on lime circle */
export const SVG_ACTION_FEATURE = `<svg ${svgStroke} class="votiq-feature-svg votiq-feature-svg--filled">
  <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" fill="currentColor" stroke="none"/>
  <path d="M9 18h6"/>
  <path d="M10 22h4"/>
</svg>`;

/** Beetle bug (report a bug) — compact top-down insect */
export const SVG_ACTION_BUG = `<svg ${svgStroke} class="votiq-feature-svg">
  <path d="M9 4 7.25 2"/>
  <path d="M15 4 16.75 2"/>
  <circle cx="12" cy="7.25" r="2"/>
  <ellipse cx="12" cy="14" rx="4.75" ry="5.25"/>
  <path d="M12 9.25v9.5"/>
  <path d="M7.25 10.75 4.75 9.75"/>
  <path d="M7 13.75 4.25 13.75"/>
  <path d="M7.25 16.75 4.75 17.75"/>
  <path d="M16.75 10.75 19.25 9.75"/>
  <path d="M17 13.75 19.75 13.75"/>
  <path d="M16.75 16.75 19.25 17.75"/>
</svg>`;

/** Legacy improve icon (feedback list screen) */
export const SVG_ACTION_IMPROVE = `<svg ${svgStroke} class="votiq-feature-svg">
  <path d="M16 7h6v6"/>
  <path d="m22 7-8.5 8.5-5-5L2 17"/>
</svg>`;

/** Speech bubble with text lines (general feedback) */
export const SVG_ACTION_GENERAL = `<svg ${svgStroke} class="votiq-feature-svg">
  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
  <path d="M8 10h8"/>
  <path d="M8 14h5"/>
</svg>`;

/** Footer: open book */
export const SVG_HUB_DOCS = `<svg ${svgStroke}>
  <path d="M12 7v14"/>
  <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"/>
</svg>`;

/** Footer: folded map */
export const SVG_HUB_ROADMAP = `<svg ${svgStroke}>
  <path d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z"/>
  <path d="M15 5.764v15"/>
  <path d="M9 3.236v15"/>
</svg>`;

/** Footer: history / changelog clock */
export const SVG_HUB_CHANGELOG_CLOCK = `<svg ${svgStroke}>
  <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
  <path d="M3 3v5h5"/>
  <path d="M12 7v5l4 2"/>
</svg>`;

/** @deprecated Use SVG_HUB_CHANGELOG_CLOCK */
export const SVG_HUB_CHANGELOG = SVG_HUB_CHANGELOG_CLOCK;

/** Google "G" mark for sign-in button */
export const SVG_GOOGLE_MARK = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" class="votiq-google-mark">
  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a9.74 9.74 0 0 1-4.18 3.11v3.27h3.57c3.48-3.21 5.48-7.94 5.48-13.37z"/>
  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-3.27c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v3.38A11.99 11.99 0 0 0 12 23z"/>
  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V6.53H2.18A11.98 11.98 0 0 0 0 12c0 1.94.46 3.77 1.28 5.38l3.56-2.77z"/>
  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 6.53l3.66 2.84C6.71 6.69 9.14 5.38 12 5.38z"/>
</svg>`;
